import "./Product.scss";
import CardNewlaunch from "../../Component/Card/CardNewlaunch.jsx";
import CardRumah from "../../Component/Card/CardRumah.jsx";
import dataNewlaunch from "./index.json";
import {
  aeorprimeImages,
  osImages,
  saImages,
  aerolinkImages,
} from "../../Assets/Product/Ruko/index.js";
import {
  elysiaImages,
  graciaImages,
  luxiaImages,
  forest5Images,
  forest6Images,
  forest7Images,
} from "../../Assets/Product/Newlaunch/index.js";
import {
  clvImages,
  fpImages,
  cmImages,
} from "../../Assets/Product/Rumah/index.js";
import flyerForestine from "../../Assets/flyer-newlaunching-forestine.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faLayerGroup,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
const imageMap = {
  elysiaImages,
  graciaImages,
  luxiaImages,
  forest5Images,
  forest6Images,
  forest7Images,
  clvImages,
  fpImages,
  cmImages,
  aeorprimeImages,
  osImages,
  saImages,
  aerolinkImages,
};
const Product = () => {
  return (
    <section className="section-produk">
      <div id="newlaunch" className="container">
        <h2 id="newlaunch-forestine" className="title">
          NEW LAUNCH
        </h2>
        <h3 className="title" style={{ color: "#004e20" }}>
          THE FORESTINE
        </h3>
        <div className="promo-forestine">
          <img
            src={flyerForestine}
            alt="Flyer The Forestine"
            className="promo-image"
          />
          <div className="promo-content">
            <ul className="promo-points">
              <li>
                <FontAwesomeIcon icon={faCircleCheck} className="check-icon" />{" "}
                Free DP
              </li>
              <li>
                <FontAwesomeIcon icon={faCircleCheck} className="check-icon" />{" "}
                Subsidi Surat Sertifikat
              </li>
              <li>
                <FontAwesomeIcon icon={faCircleCheck} className="check-icon" />{" "}
                Subsidi biaya Notaris
              </li>
              <li>
                <FontAwesomeIcon icon={faCircleCheck} className="check-icon" />{" "}
                Free PPN
              </li>
              <li>
                <FontAwesomeIcon icon={faCircleCheck} className="check-icon" />{" "}
                Free Smart Home &amp; Canopy
              </li>
              <li>
                <FontAwesomeIcon icon={faCircleCheck} className="check-icon" />{" "}
                Cicilan Start From 8JT/Bulan
              </li>
            </ul>
            <button
              className="btn-pelajari"
              onClick={() =>
                window.open(
                  "https://api.whatsapp.com/send/?phone=6281283139739&text=Halo+Daniel,%20Saya%C2%A0tertarik%20dengan%20The%20Forestine,%20boleh%20minta%20info%20lebih%20lanjut%20promo%20dan%20detailnya%20?%20https://citragardencity.id/&type=phone_number&app_absent=0",
                  "_blank",
                )
              }
            >
              Pelajari Lebih Lanjut
            </button>
          </div>
        </div>
        <div className="container-card">
          {dataNewlaunch.cardsForestine.map((data, index) => (
            <CardRumah
              key={`forestine-${index}`}
              customClass="card-forestine"
              carousel={imageMap[data.imagesKey]}
              cardID={data.cardID}
              title={data.title}
              downPaymentType={data.downPaymentType}
              descType={data.descType}
              timePeriod={data.timePeriod}
              price={data.price}
              details={data.details}
              firstIcon={faBed}
              whatsappLink={data.whatsappLink}
            />
          ))}
        </div>
      </div>
      <div className="container" style={{ marginTop: "40px" }}>
        <h2 id="newlaunch-livia" className="title">
          NEW LAUNCH
        </h2>
        <h3 className="title" style={{ color: "#BC8B62" }}>
          LIVIA LIVING
        </h3>
        <div className="container-card">
          {dataNewlaunch.cardsLivia.map((data, index) => (
            <CardNewlaunch
              carousel={imageMap[data.imagesKey]}
              cardID={data.cardID}
              title={data.title}
              downPaymentType={data.downPaymentType}
              price={data.price}
              details={data.details}
              whatsappLink={data.whatsappLink}
            />
          ))}
        </div>
      </div>
      <div className="container">
        <h2 id="rumah" className="title">
          CITRA GARDEN CITY
        </h2>
        <div className="container-card">
          {dataNewlaunch.cardsCGC.map((data, index) => (
            <CardRumah
              carousel={imageMap[data.imagesKey]}
              cardID={data.cardID}
              title={data.title}
              downPaymentType={data.downPaymentType}
              price={data.price}
              timePeriod={data.timePeriod}
              firstIcon={faBed}
              descType={data.descType}
              descType2={<div className="ket">{data.descType2}</div>} // Updated to render the actual content
              details={data.details}
              whatsappLink={data.whatsappLink}
            />
          ))}
        </div>
      </div>
      <div className="container">
        <h2 id="ruko" className="title">
          COMMERCIAL DISTRICT
        </h2>
        <div className="container-card">
          {dataNewlaunch.cardsCommercial.map((data, index) => (
            <CardRumah
              carousel={imageMap[data.imagesKey]}
              cardID={data.cardID}
              title={data.title}
              downPaymentType={data.downPaymentType}
              price={data.price}
              timePeriod={"/bln"}
              descType={data.descType}
              firstIcon={faLayerGroup}
              details={data.details}
              whatsappLink={data.whatsappLink}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Product;
